/**
 * created by li si yi
 * 线索待办处理
 */
import React from 'react';
import {connect} from "react-redux";
import BaseComponent, {contentParser} from "../../../../../base/BaseComponent";
import ViewTasksModal from "../../../../sysManagement/selectedTopicManagement/components/viewTasksModal";
import Details from "../../../../Interview/components/details";
import {taskConfig} from "../../../../Interview/taskJson/taskCreate";

class Caifangwr extends BaseComponent {
    static defaultProps = {};
    static propTypes = {};

    constructor(props) {
        super(props);
        this.state = {}
    }

    componentWillMount() {
    }

    componentDidMount() {
    }

    data = {};

    isSupport(data) {
        this.data = data;
        // console.log('媒体备案申请*------', data);
        if (this.data && this.data.data && this.data.data.id && this.data.activitiCategoryKey === "caifangwr") {
            return true;
        }
        return false;
    };
    getIcon = (data) => {
        let icon = 'IconInterview';
        return icon
    };
    //刷新回调
    handle = (data, call) => {
        this.viewTasksModal.show(data?.data?.taskId, taskConfig?.createTask?.TableList);
        this.call=call;
    };

    call=null;

    render() {
        return (
            <div style={{display: 'none'}}>
                {this.detailsModal()}
            </div>
        )
    }
    //详情页面弹窗
    detailsModal=()=>{
        return <Details ref={ref=>this.viewTasksModal=ref} callBack={()=>{
            setTimeout(()=>{
                this.call && this.call();
            },2000)
        }}/>
    };
}

function mapStateToProps(state) {
    return {
        currentUser: state.systemReducer.currentUser,
    }
}

export default connect(mapStateToProps, null, null, {forwardRef: true})(Caifangwr)